/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */


import React from 'react';
import { Link } from 'react-router-dom';

export const NotFound = () => (
  <div className='container-fluid whiteBoxWrapper mt-4'>
    <div className='loader-error'>
      <i className='fa fa-info-circle' aria-hidden='true'/>
      404 - Page was not found.
      <br /><br />

      <Link to='/'>Go to Homepage</Link>
    </div>
  </div>
);
